import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
export default {
  name: 'siderTrigger',
  props: {
    collapsed: Boolean,
    icon: {
      type: String,
      default: 'navicon-round'
    },
    size: {
      type: Number,
      default: 26
    }
  },
  methods: {
    handleChange: function handleChange() {
      this.$emit('on-change', !this.collapsed);
    }
  }
};